import { Circle } from "react-leaflet";
import { BUFFER_PANE, DELETED_DATA_OPACITY_FACTOR } from "../../utilities/constants";
import pointUtilities from "../../utilities/pointUtilities";

export const getBufferRadiusMeters = function (point) {
    const radiusMeters = parseFloat(point?.formData?.BufferRadiusMeters);
    if (isNaN(radiusMeters) || radiusMeters <= 0) {
        return null;
    }

    return radiusMeters;
}

export default function DataBuffer({ point, color, order, children }) {
    const opacity = point.isDeleted ? DELETED_DATA_OPACITY_FACTOR : 1;

    return <Circle
        center={{ lat: point.lat, lng: point.lng }}
        radius={getBufferRadiusMeters(point)}
        pane={BUFFER_PANE}
        cpm={pointUtilities.getCpm(point)}
        order={order}
        pathOptions={{ color, weight: 1, opacity, fillColor: color, fillOpacity: opacity }}>
        {children}
    </Circle>
}
